import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical }) => {
  const defaultTitle = 'AdOnRoads.com | Beta Program for Billboard Advertising';
  const defaultDescription =
    "Join the Beta of India's first digital marketplace for offline ads. Book and manage billboards online.";
  const defaultKeywords =
    'billboard advertising, OOH advertising, outdoor advertising India, digital billboard marketplace, AdOnRoads';

  const fullTitle = title ? `${title} | AdOnRoads.com` : defaultTitle;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
    </Helmet>
  );
};

export default SEO;
